import React from 'react';
import StatusBadge from '../../../ui/Status/StatusBadge';

// One status colour for a custody on every Custodies screen (list and details).
// open -> green, settled -> green, settlement_submitted (waiting for review) -> amber.
// closed -> green when fully settled (nothing remaining), red while money is still outstanding
// on it (remaining balance not zero).
const TONE_OVERRIDES = { settlement_submitted: 'warning' };

const outstanding = (remaining) => {
    const n = Number(remaining);
    return Number.isFinite(n) && Math.abs(n) >= 0.01;
};

export default function CustodyStatusBadge({ status, remaining, ...rest }) {
    if (status === 'closed') {
        const due = outstanding(remaining);
        return (
            <StatusBadge
                status={status}
                tone={due ? 'danger' : 'success'}
                title={due ? `Closed with AED ${Number(remaining).toLocaleString()} still outstanding` : 'Closed and fully settled'}
                {...rest}
            />
        );
    }
    return <StatusBadge status={status} tone={TONE_OVERRIDES[status]} {...rest} />;
}
